export function getQuarterFromYYYYMM(value: unknown): string {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  if (!Number.isFinite(n) || n < 190001) return String(value);
  const year = Math.floor(n / 100);
  const month = n % 100;
  if (month < 1 || month > 12) return String(value);
  return `Q${Math.ceil(month / 3)} ${year}`;
}
